/**
 * Shared SaaS package pricing helpers.
 */

export function computeAnnualPrice(monthlyPrice, annualDiscount = 0) {
  const monthly = parseFloat(monthlyPrice);
  const discount = parseFloat(annualDiscount);

  if (!Number.isFinite(monthly) || monthly < 0) {
    return 0;
  }

  const safeDiscount = Number.isFinite(discount) ? Math.min(Math.max(discount, 0), 100) : 0;
  return monthly * 12 * (1 - safeDiscount / 100);
}

export function computeBillingPrice(monthlyPrice, billingCycle, annualDiscount = 0) {
  if (billingCycle === 'annually' || billingCycle === 'yearly') {
    return computeAnnualPrice(monthlyPrice, annualDiscount);
  }
  const monthly = parseFloat(monthlyPrice);
  return Number.isFinite(monthly) ? monthly : 0;
}

export function formatPackagePrice(amount) {
  const value = parseFloat(amount);
  return Number.isFinite(value) ? value.toFixed(2) : '0.00';
}
